import { useContext } from 'react';
import { AttentionBeaconContext } from './attention-beacon-context';

export const useAttentionBeaconContext = () => {
  const parentContext = useContext(AttentionBeaconContext);
  const isIsolated = !parentContext;
  const {
    registerBeacon, unregisterBeacon, notifyStateChange, debugMode,
  } = isIsolated ? {} : parentContext;
  return {
    isIsolated, registerBeacon, unregisterBeacon, notifyStateChange, debugMode,
  };
};
